var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerLoadingScene } from './scenes/loading/AbfragerLoadingScene';
import { AbfragerQuestionScene } from './scenes/showQuestion/AbfragerQuestionScene';
import { AbfragerEmptyScene } from './scenes/empty/AbfragerEmptyScene';
import { runtime } from '../../classes/runtime/Runtime';
import './AbfragerStage.css';
import { Scene } from '../../classes/learnware/LearnwareEnums';
let AbfragerStage_ = class AbfragerStage_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (runtime.isServerRuntime) {
            return React.createElement(AbfragerLoadingScene, { app: app });
            return null;
            // const AbfragerTopicSSRScene = runtime.solidPackages.Server.components.AbfragerTopicSSRScene;
            // return <AbfragerTopicSSRScene app={app} />;
        }
        const { currentScene } = app.stage.stageScene;
        if (currentScene === Scene.Loading) {
            return React.createElement(AbfragerLoadingScene, { app: app });
        }
        if (currentScene === Scene.Empty) {
            return React.createElement(AbfragerEmptyScene, { app: app });
        }
        if (currentScene === Scene.PreviewQuestion) {
            return React.createElement(AbfragerQuestionScene, { question: app.edit.editCenter.centerEditItem });
        }
        if (currentScene === Scene.NoMoreQuestions) {
            if (!runtime.streamedPackages.Lazy)
                return null;
            const { NoMoreQuestionsScene } = runtime.streamedPackages.Lazy.components;
            return React.createElement(NoMoreQuestionsScene, { app: app });
        }
        if (currentScene === Scene.ShowQuestion) {
            return (React.createElement(React.Fragment, null,
                React.createElement(AbfragerQuestionScene, { question: app.answer.question })));
        }
        return 'Ungültige Szene';
    }
    componentDidMount() {
        this.props.app.appBoot.onReachedContentRendered();
    }
};
AbfragerStage_ = __decorate([
    observer
], AbfragerStage_);
export { AbfragerStage_ };
